import { Navigate, Outlet } from 'react-router';
import { LoadingScreen } from '@/components/base';
import { useAuthContext } from '@/contexts/authContext';
import { MicrophonePermissionGuard } from '@/contexts/microphonePermissionContext';
import { ActionType, LoadingLogData } from '@/interfaces/logging';
import { publicRoutes } from '@/router/routes';

const AuthenticatedRouteApp = () => {
  const { isLogin, isAuthenticating, user } = useAuthContext();

  if (isAuthenticating) {
    const loadingLogData: LoadingLogData = {
      action: ActionType.OnPageLoad,
      component: 'AuthenticatedRouteApp',
      description: 'Authenticating user',
      context: { isAuthenticating, isLogin, userId: user?.id },
    };
    return <LoadingScreen loadingLogData={loadingLogData} />;
  }

  if (!isAuthenticating && !isLogin) {
    return <Navigate to={publicRoutes.Login.getRoute()} />;
  }

  return (
    <MicrophonePermissionGuard>
      <Outlet />
    </MicrophonePermissionGuard>
  );
};

export default AuthenticatedRouteApp;
